import Pages from "components/Pages";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { PersistGate } from "redux-persist/integration/react";
import { queryClient } from "./api";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./store";
import "./styles/index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={null}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <HelmetProvider context={{}}>
              <Helmet>
                <script
                  defer
                  src="https://app.fastbots.ai/embed.js"
                  data-bot-id={process.env.REACT_APP_FASTBOTS_BOT_ID}
                ></script>
              </Helmet>
              <Pages />
            </HelmetProvider>
          </Router>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
    <Toaster
      toastOptions={{
        success: {
          duration: 1500,
        },
        error: {
          duration: 3000,
        },
      }}
    />
    <Tooltip id={"tooltipGeneric"} opacity={1} className={"tc-tooltip-dark"} />
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
